import api from './api'

const customTripService = {
  // Create custom trip
  createCustomTrip: async (tripData) => {
    const response = await api.post('/custom-trips/create', tripData)
    return response.data
  },

  // Get all custom trips (admin)
  getAllCustomTrips: async (params = {}) => {
    const response = await api.get('/custom-trips', { params })
    return response.data
  },

  // Get single custom trip
  getCustomTripById: async (id) => {
    const response = await api.get(`/custom-trips/${id}`)
    return response.data
  },

  // Get user's custom trips
  getMyCustomTrips: async () => {
    const response = await api.get('/custom-trips/my-trips')
    return response.data
  },

  // Update trip status (admin)
  updateTripStatus: async (id, status, adminNotes = '') => {
    const response = await api.put(`/custom-trips/${id}/status`, {
      status,
      admin_notes: adminNotes,
    })
    return response.data
  },

  // Delete custom trip (admin)
  deleteCustomTrip: async (id) => {
    const response = await api.delete(`/custom-trips/${id}`)
    return response.data
  },

  // Get user notification count (trips with status changes not viewed)
  getUserNotificationCount: async () => {
    const response = await api.get('/custom-trips/notifications/user-count')
    return response.data
  },

  // Get admin notification count (new pending trips not viewed)
  getAdminNotificationCount: async () => {
    const response = await api.get('/custom-trips/notifications/admin-count')
    return response.data
  },

  // Mark trip as viewed by user
  markAsViewedByUser: async (id) => {
    const response = await api.put(`/custom-trips/${id}/mark-viewed-user`)
    return response.data
  },

  // Mark trip as viewed by admin
  markAsViewedByAdmin: async (id) => {
    const response = await api.put(`/custom-trips/${id}/mark-viewed-admin`)
    return response.data
  },
}

export default customTripService
